// react
import React from "react"
import { Link } from "react-router"
// app
import "./header.styl"


export default ({
    isAdmin,
    isLoggedIn,
    userName,
    onExport
}) =>
    <header>
        <div className="container">
            <div className="row">
                <div className="col-xs-6">
                    <a className="home" href="//www.aviationnetwork.com"></a>
                </div>
                <div className="col-xs-6 text-right">
                    { isLoggedIn === true && isAdmin === true ?
                        <div className="link">
                            <Link to="/profile/new">New Profile</Link>
                        </div>
                        : null
                    }
                    { isLoggedIn === true && isAdmin !== true ?
                        <div className="link">
                            <Link to="/profile">My Profile</Link>
                        </div>
                        : null
                    }
                    { isLoggedIn === true && isAdmin === true ?
                        <div className="link">
                            <Link to="/search">Search</Link>
                        </div>
                        : null
                    }
                    { isLoggedIn === true && isAdmin === true ?
                        <div className="link">
                            <a href="#" onClick={ onExport }>Export DB</a>
                        </div>
                        : null
                    }
                    { isLoggedIn === true ?
                        null :
                        <div className="link">
                            <Link to="/login">Login</Link>
                        </div>
                    }
                    { isLoggedIn === true ?
                        null :
                        <div className="link">
                            <Link to="/signup">Sign Up</Link>
                        </div>
                    }
                    { isLoggedIn === true ?
                        <div className="link">
                            <Link to="/account"><small>Welcome, { userName }</small></Link>
                        </div>
                        : null
                    }
                </div>
            </div>
        </div>
    </header>


/** WEBPACK FOOTER **
 ** ./src/components/common/Header/header.js
 **/